import React from 'react';
import { useSearchBarContext } from 'components/Filters/context/SearchBarContext/SearchBarContext';
import {
    ContentSuggestionParams,
    Suggestions,
    isContentSuggestion,
} from 'components/Filters/context/SearchBarContext/types';
import { FiltersParams } from 'types/params';
import * as Styled from '../styled';
import SuggestionItem from './SuggestionItem';
import { ContentSuggestionItem } from './ContentSuggestionItem';

export const _SuggestionsList = ({
    suggestions,
    selectedSuggestionIndex,
}: {
    suggestions: Suggestions[];
    selectedSuggestionIndex: number;
}) => {
    const hasNoSuggestion = !suggestions || suggestions.length === 0;

    if (hasNoSuggestion) {
        return null;
    }

    return (
        <Styled.List>
            {suggestions?.map((suggestion, index) => {
                switch (true) {
                    case isContentSuggestion(suggestion): {
                        const [[params, code], suggestionType] = suggestion;

                        return (
                            <ContentSuggestionItem
                                key={`suggestion-${params}-${code}-${suggestionType}`}
                                modifiers={[
                                    params as ContentSuggestionParams,
                                    code,
                                ]}
                                suggestionType={suggestionType}
                                isSelected={index === selectedSuggestionIndex}
                            />
                        );
                    }
                    default: {
                        const [[params, code], suggestionType] = suggestion;

                        return (
                            <SuggestionItem
                                key={`suggestion-${params}-${code}-${suggestionType}`}
                                modifiers={[params as FiltersParams, code]}
                                suggestionType={suggestionType}
                                isSelected={index === selectedSuggestionIndex}
                            />
                        );
                    }
                }
            })}
        </Styled.List>
    );
};

const SuggestionsList = () => {
    const { suggestions, selectedSuggestionIndex } = useSearchBarContext();

    return (
        <_SuggestionsList
            suggestions={suggestions}
            selectedSuggestionIndex={selectedSuggestionIndex}
        />
    );
};

export default SuggestionsList;
